module.exports = __webpack_public_path__ + "img/bg7.0ee766ca.png";